import styled from "styled-components";

export const FormContainer = styled.div`
  max-width: 380px;
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
`;

export const FormTitle = styled.h2`
  margin: 10px 0;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
